<template>
  <ChatbotAboutLayout
    title="Quantum HR Workflow Assistant"
    what-it-is-subtitle="Hire quantum talent with confidence"
    :description-paragraphs="descriptionParagraphs"
    :features="features"
    audience-subtitle="Designed for HR and talent teams"
    :audience-items="audienceItems"
    :resources="resources"
    :video="video"
    cta-text="Ready to try it? Open the live assistant →"
    cta-route-name="quantumHRWorkflowAssistantTab"
  />
</template>

<script>
import ChatbotAboutLayout from "@/components/ChatbotAboutLayout.vue";

export default {
  components: {
    ChatbotAboutLayout,
  },
  setup() {
    const descriptionParagraphs = [
      "Hiring in quantum computing is specialised and hard to benchmark. This assistant guides HR professionals through a five-step conversation — from defining a role to a ready-to-execute hiring plan.",
      "It uses your answers (and optionally your company website) plus a database of 10,000+ real quantum job listings to produce data-backed requirements, job-post drafts, and an implementation roadmap.",
    ];

    const features = [
      {
        title: "Define your hiring need",
        text: "Clarify the role, seniority, and hiring goal through focused questions.",
      },
      {
        title: "Build a market-informed job post",
        text: "Compare requirements to real listings, then draft and optimise for LinkedIn, ATS, D&I, and social channels.",
      },
      {
        title: "Get an execution roadmap",
        text: "Receive phased actions with timelines, owners, and AI vs. human steps to share with your team.",
      },
    ];

    const audienceItems = [
      {
        title: "Who it's for",
        text: "HR professionals, recruiters, and hiring managers in quantum or deep-tech organisations.",
      },
      {
        title: "Best use cases",
        text: "Opening a new quantum role, refreshing job descriptions, or aligning hiring plans with market demand and standards.",
      },
      {
        title: "Recurring usefulness",
        text: "Use for each new hire, annual role reviews, or when expanding into new quantum domains or locations.",
      },
    ];

    const resources = [
      {
        label: "Global quantum job trends (EQRC Dashboard)",
        href: "https://dashboard.hybridintelligence.eu/",
        description: "Explore workforce data that informs the assistant's recommendations.",
      },
    ];

    const video = {
      src: "/videos/QHWA_subtitles.mp4",
      type: "video/mp4",
    };

    return {
      descriptionParagraphs,
      features,
      audienceItems,
      resources,
      video,
    };
  },
};
</script>
